import React from 'react'
import { Icon } from './Logout.elements'

type Props = {
  className?: string
}

export const LogoutIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 25 25"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <path d="M15.232 12.855H3.254M7.246 8.863l-3.992 3.993 3.992 3.993" stroke="#B1B7BA" strokeWidth="1.996"/>
    <path d="M8.245 3.872h9.982V21.84H8.245" stroke="currentColor" strokeWidth="1.996"/>
  </Icon>
)
